import "./SingleProductTemplate.module.css"
import Intestazione from "@/reusable_sections/Header"
import SingleProductTemplateSection from "./sections/SingleProductTemplateSection"
import PieDiPagina from "@/reusable_sections/Footer"

export default function SingleProductTemplatePage() {

  return (
    <div>
      <Intestazione />
      <SingleProductTemplateSection />
      <PieDiPagina />
    </div>
  )
}
